import { createNanoBananaRunner } from './nanoBanana';
import type { ModelRunCredits } from '@/api/modelPrediction';
import type { CompositorImageSource } from '@/components/Recipe/Views/CompositorView';
import type { ResolvedModelPrice } from '@/components/Nodes/Utils';
import type { CompositorAiRun } from './CompositorAiTasks';
import type { Base64Image, LayerId } from 'web';

export { getNanoBananaParams as getInpaintParams } from './nanoBanana';
export type { ImageEditResult as InpaintImage, ImageEditRunner as InpaintRunner } from './nanoBanana';

const INPAINT_SYSTEM_PROMPT = `Image 1 is the original image to edit. Image 2 is its black-and-white editing mask.
White areas indicate where to apply the user's instructions; black areas must remain unchanged.
Preserve the original framing, composition, and lighting outside the masked area.
Return only the edited image, without the mask or any added markings.`;

export interface InpaintParams {
  prompt: string;
  groupName: string;
}

export interface InpaintOptions {
  groupName: string;
  modelLabel: string;
  getPrice: () => ResolvedModelPrice | undefined;
}

export function createInpaintAction({ groupName, modelLabel, getPrice }: InpaintOptions) {
  return {
    modelLabel,
    getPrice,
    createRun(prompt: string): CompositorAiRun {
      return {
        action: 'inpaint',
        params: { prompt, groupName },
      };
    },
  };
}

export type InpaintAction = ReturnType<typeof createInpaintAction>;

export function createInpaintRunner(
  getSource: (layerId: LayerId) => CompositorImageSource | undefined,
  prepareMask: () => Base64Image | undefined,
  onCredits?: (credits: ModelRunCredits) => void,
) {
  return createNanoBananaRunner('inpaint', INPAINT_SYSTEM_PROMPT, getSource, prepareMask, onCredits);
}
